<template>
  <div class="continer">
    <HeaderTop></HeaderTop>
    <CompanyTitle></CompanyTitle>
    <RouterList></RouterList>
    <Banner></Banner>
    <!-- 面包屑 -->
    <div class="navigation">
      <span>当前位置&nbsp;:&nbsp;</span>
      <router-link to="/">&nbsp;首页&nbsp;>&nbsp;</router-link>
      <router-link to="/result">政策法规</router-link>
    </div>
    <!-- 版心 -->
    <div class="details">
      <ul>
        <li @click="_getexhibition(item.id)" v-for="(item,index) in resultList" :key="index">
          <span>{{item.lable}}</span>
          <em>{{item.updataTime}}</em>
        </li>
      </ul>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { regulations_query } from '../api/user/index'
import { ERR_OK } from '../api/common/config'
import HeaderTop from '@/components/header-top/header-top.vue'
import CompanyTitle from '@/components/company-title/company-title.vue'
import RouterList from '@/components/router-list/router-list.vue'
import Banner from '@/components/banner/banner.vue'
import Footer from '@/components/footer/footer.vue'
export default {
  components: {
    HeaderTop,
    CompanyTitle,
    RouterList,
    Banner,
    Footer
  },
  data() {
    return {
      resultList:[]
    }
  },
  mounted(){
    this._regulations_query()
  },
  methods:{
    _getexhibition(id) {
        this.$router.push({ path: '/police-details',query:{id} })
    },
    _regulations_query(){
      regulations_query({number:6,page:1}).then((res)=>{
        if(res.data.isok === ERR_OK){
          // console.log(res)
          this.resultList = res.data.data.records
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.continer
  .navigation
    width 1200px
    height 52px
    background rgba(255,255,255,1)
    margin 30px auto 10px
    box-shadow 0px 0px 10px 0px rgba(0, 0, 0, 0.05)
    font-size 12px
    padding 18px 20px
    box-sizing border-box
    span,a 
      color #666666
    a:nth-child(3)
      color #3377FF
  .details
    width 1200px
    margin 0 auto
    height 486px
    background rgba(255,255,255,1)
    box-shadow 0px 0px 8px 0px rgba(0, 0, 0, 0.06)
    margin-bottom 110px
    ul
      padding 0 20px
      box-sizing border-box
      li
        font-size 12px
        color #333
        height 80px
        line-height 80px
        border-bottom 1px dashed #ccc
        display flex 
        flex-wrap wrap 
        justify-content space-between
        &:hover 
          color #3377FF
        &:nth-child(6) 
          border 0
        span
          width 700px
          display inline-block
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
</style>
